export default {
    title: '供應商一覽'
}
